class CartPopup extends HHBaseElement {
  CLOSE_TIMEOUT = 3000
  SELECTORS_TO_UPDATE = [
    '[data-cart-gwp]',
    '[data-cart-footer]',
    '[data-cart-content]',
    '[data-cart-items-count]',
    'price-progress',
  ]
  constructor() {
    super()
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.lastActiveElement = null
    this.updateLastActiveElement = this.updateLastActiveElement.bind(this)
    this._show = this._show.bind(this)
    this._hide = this._hide.bind(this)
    this._handleDocumentClick = this._handleDocumentClick.bind(this)
    this.setPosition = this.setPosition.bind(this)
    this.closeBtn = this.querySelector('[data-cart-close]')
    this.cartItemCountInHeader = document.querySelector(
      '[data-header-cart-count]'
    )
    setTimeout(() => {
      this.classList.add('block')
    }, 300)
  }

  connectedCallback() {
    this._attachListeners()
    this.setPosition()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  static get observedAttributes() {
    return ['anchor']
  }

  get anchorElement() {
    return document.querySelector(this.getAttribute('anchor'))
  }

  setPosition() {
    try {
      const bounds = this.anchorElement.getBoundingClientRect()
      this.style.setProperty(
        '--cart-popup-anchor-offset-top',
        20 + bounds.top + bounds.height + 'px'
      )

      this.style.setProperty(
        '--cart-popup-anchor-offset-right',
        bounds.left + bounds.width * 2 + 'px'
      )
    } catch (error) {}
  }

  _handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close()
    }
  }

  _attachListeners() {
    document.addEventListener('cart-popup::open', this.open)
    document.addEventListener('click', this._handleDocumentClick)
    document.addEventListener('focus', this.updateLastActiveElement, true)
    this.addEventListener('pointerenter', this._handlePointerEnter)
    this.addEventListener('pointerleave', this._handlePointerLeave)
    this.closeBtn.addEventListener('click', this.close)
    this.addEventListener('nosto::rendered', this.setPosition)
  }

  _removeListeners() {
    document.removeEventListener('cart-popup::open', this.open)
    document.removeEventListener('click', this._handleDocumentClick)
    document.removeEventListener('focus', this.updateLastActiveElement, true)
    this.closeBtn.removeEventListener('click', this.close)
    this.removeEventListener('nosto::rendered', this.setPosition)
  }

  updateLastActiveElement() {
    this.lastActiveElement = document.activeElement
  }

  async open(event) {
    this.previousElement = this.lastActiveElement
    await this.update(event.detail.items)
    this._show()
  }

  close() {
    this._hide()
    if (!this.previousElement) return
    this.previousElement.focus()
    this.previousElement = null
  }

  _show() {
    this.setPosition()
    this.classList.add('active')
    setTimeout(() => {
      this._setupFocusTrap();
      this.closeBtn.focus();
    }, 100);
  }

  _hide() {
    this.classList.remove('active')
  }

  async update(items = []) {
    const response = await fetch(`${__GLOBAL__.routes.rootUrl}/cart?view=popup`)
    const element = document.createElement('div')
    element.innerHTML = await response.text()
    const $lineItems = Array.from(
      element.querySelectorAll('[data-cart-content] .cart-popup__item')
    )

    $lineItems.forEach(($lineItem, index) => {
      if (
        !items.find(
          (item) => String(item.id) === $lineItem.getAttribute('line-item-id')
        )
      ) {
        $lineItem.remove()
      }
    })

    this.SELECTORS_TO_UPDATE.forEach((selector) => {
      const content = element.querySelector(selector)
      if (!content) return
      if (selector === '[data-cart-items-count]') {
        this.cartItemCountInHeader.innerHTML = content.dataset.count
        this.cartItemCountInHeader.classList.remove('hidden')
      } else if (selector === 'price-progress') {
        if (this.querySelector(selector)) {
          this.querySelector(selector).value = content.value
        }
      } else {
        this.querySelector(selector).innerHTML = content.innerHTML
      }
    })
  }
}
window.customElements.define('cart-popup', CartPopup)
